import { HttpService, IResponse } from "nest-utilities-client";
import { useAuth } from "../authentication/authentication.context";
import { authenticationService } from "../authentication/authentication.service";

class Service extends HttpService {
  public authContext: ReturnType<typeof useAuth> | null = null;

  getHeaders(url: string, init: RequestInit) {
    const headers: Record<string, string> = {
      authorization: authenticationService.getSession()?.token ?? "",
    };

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (timezone) {
        headers["x-timezone"] = timezone;
      }
    } catch {
      // eslint-disable-next-line no-console -- Disable console error logging for this non-critical error
      console.error(
        "Failed to get user's timezone. This is not critical, so the error is ignored.",
      );
    }

    return headers;
  }

  onRequestError(error: IResponse<Error>) {
    // clear the session token if its invalid
    if (error.status === 401) {
      this.authContext?.logout();
    }
  }
}

export const httpService = new Service();
